// Blocklist read-only gate copy; kept textually in sync with RRC's READ_ONLY_REASON (no shared source).
export const BLOCKLIST_READ_ONLY_REASON =
  'Requires global or location blocklist edit permission for all applicable locations.';
